export default __webpack_public_path__ + "static/media/ShareGrey.0e52688d.svg";